import { Input } from "@newsela/angelou";
import { STANDARDS_SET_MODE } from "@/search/NewSearchPageMVP/types/IStandardsSetMode";
import { useStandardsModalContext } from "@/search/NewSearchPageMVP/provider/StandardsModalProvider";
import { useStandardsModalTitleInput } from "./hooks";

export const StandardsSetsTitleInput = () => {
  const {
    getters: {
      standardsSetMode,
      standardsSetTitleError,
      isPublishingStandardsSet,
      isUpdatingStandardsSet,
    },
  } = useStandardsModalContext();

  const {
    inputTitle,
    handleTitleChange,
    standardsSetTitleTouched,
    setStandardsSetTitleTouched,
  } = useStandardsModalTitleInput();

  return (
    <Input
      label={`${standardsSetMode === STANDARDS_SET_MODE.CREATE ? "New" : "Edit"} standards set title`}
      inputType={Input.inputTypes.text}
      error={standardsSetTitleError}
      onBlur={() => {
        if (!standardsSetTitleTouched) {
          setStandardsSetTitleTouched(true);
        }
      }}
      onChange={handleTitleChange}
      touched={standardsSetTitleTouched}
      value={inputTitle}
      placeholder="Enter a title for your custom standards set"
      underInputId="standards-set-title"
      disabled={isPublishingStandardsSet || isUpdatingStandardsSet}
      dataProps={{
        "data-qa-selector": "standards-modal-text-input",
      }}
    />
  );
};
